export default __webpack_public_path__ + "static/uiuxcase3-192be8671489faad7536c07f468db68e.png";